module.exports = __webpack_public_path__ + "img/natura.99879ed2.svg";